export default "__VITE_ASSET__dEpbDylpovxRec9sundjFw__"